import CallMadeIcon from '@mui/icons-material/CallMade';
import { Button, ButtonProps, ButtonTypeMap, Tooltip } from '@mui/material';
import clsx from 'clsx';
import React from 'react';
import { NavLink, To } from 'react-router-dom';
import style from './index.module.scss';

interface Props {
  className?: string;
  children: string;
  to: To;
  title?: React.ReactNode;
}

export const ButtonGoTo = <
  D extends React.ElementType = ButtonTypeMap['defaultComponent'],
  P = {},
>({
  title,
  className,
  to,
  children,
  ...rest
}: Props & ButtonProps<D, P>) => {
  return (
    <Tooltip title={title || children}>
      <Button
        component={NavLink}
        startIcon={<CallMadeIcon />}
        variant={'outlined'}
        color={'secondary'}
        size={'small'}
        className={clsx(style.root, className)}
        to={to}
        {...rest}
      >
        {children}
      </Button>
    </Tooltip>
  );
};
